function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { GalleryComponent } from '../../galleryComponent';
import { URL_TYPES, URL_SIZES } from '../../../common/constants/urlTypes';
import PlayBackground from '../../svgs/components/play_background';
import PlayTriangle from '../../svgs/components/play_triangle';

var VideoItemPlaceholder =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(VideoItemPlaceholder, _GalleryComponent);

  function VideoItemPlaceholder() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = VideoItemPlaceholder.prototype;

  _proto.createImageElement = function createImageElement() {
    return React.createElement("canvas", {
      key: 'image-' + this.props.id,
      alt: this.props.alt ? this.props.alt : 'untitled video',
      className: 'gallery-item-hidden gallery-item-visible gallery-item gallery-item-preloaded ' + (this.props.loadingStatus.loaded ? ' gallery-item-loaded ' : '') + (this.props.loadingStatus.failed ? ' failed ' : ''),
      "data-src": this.props.createUrl(URL_SIZES.RESIZED, URL_TYPES.HIGH_RES)
    });
  };

  _proto.render = function render() {
    var _ref = this.props.imageDimensions || {},
        marginLeft = _ref.marginLeft,
        marginTop = _ref.marginTop,
        restOfDimensions = _objectWithoutPropertiesLoose(_ref, ["marginLeft", "marginTop"]);

    var showVideoControls = this.props.hidePlay ? false : this.props.styleParams.showVideoPlayButton;
    var videoControls = !showVideoControls ? false : [React.createElement("i", {
      key: "play-triangle",
      "data-hook": "play-triangle",
      className: 'gallery-item-video-play-triangle play-triangle '
    }, React.createElement(PlayTriangle, null)), React.createElement("i", {
      key: "play-bg",
      "data-hook": "play-background",
      className: 'gallery-item-video-play-background play-background '
    }, React.createElement(PlayBackground, null))];
    var baseClassName = 'gallery-item-content gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item video-item';
    var placeHolder = React.createElement("div", {
      className: baseClassName,
      "data-hook": "video-placeholder_container-image-element",
      key: 'video-and-hover-container' + this.props.id,
      style: _objectSpread({
        backgroundImage: "url(" + this.props.createUrl(URL_SIZES.RESIZED, URL_TYPES.HIGH_RES) + ")"
      }, restOfDimensions)
    }, this.createImageElement(), videoControls);
    var hover = this.props.hover;
    return React.createElement("div", {
      key: 'video-and-hover-container' + this.props.idx
    }, [placeHolder, hover]);
  };

  return VideoItemPlaceholder;
}(GalleryComponent);

export default VideoItemPlaceholder;